window.bundleapp = window.bundleapp || {};
window.bundleapp.settings = Object.assign({}, window.bundleapp.settings || {}, {
  bab: {
    productImage: 600
  }
});

document.body.addEventListener("click", async (event) => {
  if (!event.target.matches(".cart__remove-bundle *, .cart__remove-bundle[data-bundle-id]")) return;

  const bundleElement = event.target.closest(".cart__remove-bundle") || (event.target.hasAttribute("data-bundle-id") ? event.target : null);
  const bundle_id = bundleElement ? bundleElement.getAttribute("data-bundle-id") : null;

  if (bundle_id) {
    event.preventDefault();
    try {
      // Get current cart contents
      const cart = await (await fetch("/cart.js")).json();

      // Create data object for cart update AJAX call
      const data = {
        updates: cart.items.reduce((acc, item) => (item.properties?._bundleUid == bundle_id ? { ...acc, [item.key]: 0 } : acc), {})
      };

      // API call to update the cart contents and set the bundle item quantities to 0
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data)
      });
      response.ok && (window.location.href = "/cart");
    } catch (error) {
      console.error(error);
    }
  }
});

// if (window.location.href.includes("/tools/bundle-subscriptions/bundle/")) {
//   const observer = new MutationObserver((mutationsList, observer) => {
//     if (document.body.classList.contains("awt-bab-open")) {
//       observer.disconnect();
//       setTimeout(() => {
//         document.body.classList.remove("subscription-overlay-open");
//       }, 50);
//     }
//   });
//   observer.observe(document.body, { attributes: true, attributeFilter: ["class"] });

//   setTimeout(() => {
//     observer.disconnect();
//   }, 5000);
// }
